export const UPDATE_FORM_ID = 'updateStationForm';
export const CREATE_FORM_ID = 'createStationForm';
